import { render, staticRenderFns } from "./NaverShoppingConfig.vue?vue&type=template&id=c203f0e2&"
import script from "./NaverShoppingConfig.vue?vue&type=script&lang=ts&"
export * from "./NaverShoppingConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports